/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvQXN5bHVtL2lkZW50aXR5LXZhZ3JhbnQvc3JjL2FzeWx1bS1pZGVuZXRpdHkvc3JjL2FwcC91c2VyL2xvZ291dC9sb2dvdXQuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9Vc2Vycy9Bc3lsdW0vaWRlbnRpdHktdmFncmFudC9zcmMvYXN5bHVtLWlkZW5ldGl0eS9zcmMvYXBwL3VzZXIvbG9nb3V0L2xvZ291dC5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/aot/app/user/logout/logout.component.css.shim.ngstyle.ts